import React from 'react';

const About = () => {
    return (
        <section id="about" className="section-padding bg-luxury-cream relative overflow-hidden">
            <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                {/* Image Grid */}
                <div className="grid grid-cols-2 gap-4 relative">
                    <img
                        src="https://images.unsplash.com/photo-1509941943102-10c232535736?q=80&w=2070&auto=format&fit=crop"
                        alt="Watchmaking"
                        className="rounded-lg shadow-2xl translate-y-8"
                    />
                    <img
                        src="https://images.unsplash.com/photo-1594576722512-582bcd46fba3?q=80&w=1935&auto=format&fit=crop"
                        alt="Craftsmanship"
                        className="rounded-lg shadow-2xl"
                    />
                    {/* Decorative Circle */}
                    <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-luxury-gold/10 rounded-full blur-3xl" />
                </div>

                {/* Content */}
                <div>
                    <h3 className="text-luxury-gold uppercase tracking-widest mb-2">Our Heritage</h3>
                    <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-luxury-black">Crafting Time Since 1920</h2>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                        For over a century, LuxeTime has been synonymous with precision, elegance, and innovation.
                        Our master watchmakers dedicate countless hours to perfecting every movement, ensuring that
                        each timepiece is not just an instrument of time, but a work of art.
                    </p>
                    <p className="text-gray-600 mb-8 leading-relaxed">
                        We believe that a watch tells more than time; it tells a story. A story of tradition,
                        excellence, and the relentless pursuit of perfection.
                    </p>

                    <div className="grid grid-cols-3 gap-8 border-t border-luxury-gold/20 pt-8">
                        <div>
                            <h4 className="text-3xl font-serif font-bold text-luxury-gold mb-1">100+</h4>
                            <p className="text-sm text-gray-500 uppercase tracking-wide">Years</p>
                        </div>
                        <div>
                            <h4 className="text-3xl font-serif font-bold text-luxury-gold mb-1">50k+</h4>
                            <p className="text-sm text-gray-500 uppercase tracking-wide">Clients</p>
                        </div>
                        <div>
                            <h4 className="text-3xl font-serif font-bold text-luxury-gold mb-1">25</h4>
                            <p className="text-sm text-gray-500 uppercase tracking-wide">Awards</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
